import resetGTMDataLayer from './dataLayer.utils';

function addToLoginSuccessEvent(attemptsNeeded) {
  resetGTMDataLayer();
  window.dataLayer.push({ event: 'login_success', attemptsNeeded });
}

export default addToLoginSuccessEvent;
